<div class="zmenu">
  <div
    *ngFor="let menu of menuList"
    class="zmenu-button zmenu-button__cond zmenu-button__cond--show"
    [class.zmenu-button__cond--enabled]="menu.condition ? menu.condition() : true"
    (click)="onClick(menu)"
  >
    <i class="material-icons">{{ menu.icon }}</i>
    <span [class.long-label]="getMenuTitle(menu).length > 13">{{ getMenuTitle(menu) }}</span>
  </div>
</div>
